module.exports = __webpack_public_path__ + "img/illustrator_logo.2f213b2f.jpg";